<template>
  <div>
    <card :title="supplier ? supplier.name : ''">
      <div class="card-header-custom">
        <button class="btn btn-fill btn-primary"
          @click.prevent="openAssignProductDialog"
        >
          <i class="fa fa-plus"></i> Zuweisen
        </button>
      </div>
      <supplier-products-table :products="products" />
      <l-pagination
        background
        layout="prev, pager, next"
        :per-page="10"
        :page-count="pageCount"
        :value="currentPage"
        @input="changePage"
        @changePerPage="changePerPage"
      />
    </card>
    <assign-product-dialog
      :show="showAssignProductDialog"
      :products="assignableProducts"
      @assignProduct="assignProduct"
      @close="showAssignProductDialog = false"
      :val-errors="assignErrors"
    />
  </div>
</template>

<script>
import hasPagination from 'src/has-pagination'
import SupplierProductsTable from './supplier-products-table'
import AssignProductDialog from './../assign-product-dialog'

export default {
  components: { SupplierProductsTable, AssignProductDialog },
  data () {
    return {
      supplier: null,
      products: [],
      showAssignProductDialog: false,
      assignableProducts: [],
      assignErrors: []
    }
  },
  mixins: [hasPagination],
  methods: {
    getData (query) {
      this.$http.get(`/suppliers/${this.$route.params.id}/products?${query}`).then(({ data }) => {
        this.products = data.data.map(stockRotation => {
          const product = { ...stockRotation, ...stockRotation.product }
          product.referenznummer = stockRotation.referenznummer
          product.product_supplier_id = stockRotation.id
          return product
        })
        this.pageCount = data.last_page
      })
    },
    openAssignProductDialog () {
      this.$http.get(`/products?not_supplier=${this.supplier.id}`).then(({ data }) => {
        this.assignableProducts = data
        this.showAssignProductDialog = true
      })
    },
    async assignProduct (payload) {
      await this.initCsrf()

      // const url = `/products/${payload.product_id}/suppliers/${this.supplier.id}`
      const url = `/suppliers/${this.supplier.id}/products/${payload.product_id}`
      this.$http.post(url, { price: payload.price, referenznummer: payload.referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferant  zugewiesen.',
          type: 'success'
        })
        this.showAssignProductDialog = false

        const product = { ...data, ...data.product }
        product.referenznummer = data.referenznummer
        product.product_supplier_id = data.id

        this.products.unshift(product)
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/suppliers/${this.$route.params.id}`).then(({ data }) => { this.supplier = data })
    this.fetchTableData()
  }
}
</script>
